import { get, post } from "./http.service";
import { getSearchListQuery } from "../utils/utils";

const PitchTemplateService = {
    getPitchTemplateData: () => get(`catalogues`),
    getemailtemplates: (body) => get(`getemailtemplates${getSearchListQuery(body)}`),
    sendEmail: (body) => post(`persistentemail`, body),
};
export default PitchTemplateService;
